import axios from 'axios';

export const getBlogsData = () => {
  return axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
};

export const getSingleBlog = (slug) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/blog/${slug}`);
};
